/*
 * MDB shim for MDBDatePicker
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Deliveries/inventoryTracking.jsx
 */

import MUITextField from "@mui/material/TextField";

export default function MDBDatePicker({ value, getValue, onChange, label, ...rest }) {
    function handleChange(event) {
        onChange?.(event);
        getValue?.(event.target.value);
    }

    return (
        <MUITextField
            type="date"
            label={label}
            value={value || ""}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            {...rest}
        />
    );
}
